import { isoToDatetimeLocalValue } from '../services/crmService';

export const FOLLOW_UP_DEFAULT_DAYS = 5;
export const MAX_OUTREACH_TOUCHES = 2;
export const TOUCH_FOLLOW_UP_DELAY_DAYS: Record<number, number> = { 1: 3 };

function addDaysLocal(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return isoToDatetimeLocalValue(d.toISOString());
}

/** Editable default for datetime-local inputs when no follow-up is scheduled yet. */
export function defaultFollowUpDatetimeLocal(): string {
  return addDaysLocal(FOLLOW_UP_DEFAULT_DAYS);
}

/** ISO string for quick actions that persist follow-up immediately. */
export function defaultFollowUpIso(): string {
  const d = new Date();
  d.setDate(d.getDate() + FOLLOW_UP_DEFAULT_DAYS);
  return d.toISOString();
}

export function suggestedFollowUpDatetimeLocal(options?: {
  touches?: number;
  templateDelayDays?: number | null;
}): string {
  const touches = options?.touches ?? 0;
  if (touches >= MAX_OUTREACH_TOUCHES - 1) {
    return '';
  }
  const templateDelay = options?.templateDelayDays;
  if (typeof templateDelay === 'number' && templateDelay >= 0) {
    return addDaysLocal(templateDelay);
  }
  const nextTouch = touches + 1;
  const delay = TOUCH_FOLLOW_UP_DELAY_DAYS[nextTouch] ?? FOLLOW_UP_DEFAULT_DAYS;
  return addDaysLocal(delay);
}

/** Prefill reminder: keep future dates; replace overdue/missing with touch-aware suggestion. */
export function followUpReminderPrefill(
  iso: string | null | undefined,
  touches?: number,
  templateDelayDays?: number | null
): string {
  if (iso) {
    const due = new Date(iso);
    if (!Number.isNaN(due.getTime()) && due.getTime() > Date.now()) {
      const local = isoToDatetimeLocalValue(iso);
      if (local) return local;
    }
  }
  return suggestedFollowUpDatetimeLocal({ touches, templateDelayDays });
}

export function followUpDatetimeLocalOrDefault(iso: string | null | undefined): string {
  const fromIso = isoToDatetimeLocalValue(iso);
  return fromIso || defaultFollowUpDatetimeLocal();
}
